import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { usePageMeta } from "@/lib/seo";
import { Package, Flame, Hammer } from "lucide-react";

export default function DepartmentsPage() {
  const [cats, setCats] = useState([]);
  usePageMeta(
    "All Departments",
    "Browse every department at IPVALUE Marketplace — furniture, mattresses, appliances, e-bikes, scooters, tools, electronics and wholesale pallets in Grand Rapids, MI."
  );
  useEffect(() => {
    api.get("/products/categories").then((r) => setCats(r.data.categories || [])).catch(() => {});
  }, []);

  return (
    <div data-testid="departments-page">
      <section className="bg-[#0A1C40] border-b-4 border-[#FFC220]">
        <div className="max-w-[1200px] mx-auto px-6 md:px-8 py-12">
          <div className="ipv-eyebrow text-[#FFC220]">Shop by department</div>
          <h1 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tighter text-white mt-3">
            All Departments
          </h1>
        </div>
      </section>

      <section className="max-w-[1200px] mx-auto px-6 md:px-8 py-10">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
          <Link to="/pallets" className="border-2 border-[#0A1C40] bg-[#0A1C40] text-white p-6 hover:bg-black transition-colors" data-testid="dept-tile-pallets">
            <Package className="w-6 h-6 text-[#FFC220]" />
            <div className="font-display font-black text-lg mt-3">Wholesale Pallets</div>
            <div className="text-sm text-white/70 mt-1">Manifested &amp; unmanifested closeout pallets</div>
          </Link>
          <Link to="/build-pallet" className="border-2 border-[#C9971E] bg-[#FFC220] p-6 hover:brightness-105 transition-all" data-testid="dept-tile-build-pallet">
            <Hammer className="w-6 h-6 text-[#0A1C40]" />
            <div className="font-display font-black text-lg mt-3 text-[#0A1C40]">Build Your Own Pallet</div>
            <div className="text-sm text-[#0A1C40]/80 mt-1">Pick your items — one pallet price</div>
          </Link>
          <Link to="/deals" className="border-2 border-[#DC2626] p-6 hover:bg-red-50 transition-colors" data-testid="dept-tile-deals">
            <Flame className="w-6 h-6 text-[#DC2626]" />
            <div className="font-display font-black text-lg mt-3 text-[#DC2626]">Hot Deals</div>
            <div className="text-sm text-gray-600 mt-1">Markdowns &amp; bulk-buy savings</div>
          </Link>
          {cats.map((c) => (
            <Link
              key={c}
              to={`/shop/${encodeURIComponent(c)}`}
              className="border-2 border-gray-200 p-6 hover:border-[#0A1C40] transition-colors group"
              data-testid={`dept-tile-${c.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            >
              <div className="font-display font-black text-lg group-hover:text-[#0A1C40]">{c}</div>
              <div className="text-sm text-gray-500 mt-1">Shop {c} →</div>
            </Link>
          ))}
        </div>
        {cats.length === 0 && (
          <div className="text-center text-gray-500 py-10" data-testid="departments-loading">Loading departments…</div>
        )}
      </section>
    </div>
  );
}
